(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form-reason"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('form-success-flag')) {
      var container = document.querySelector('.container-form');
      if (container) {
        container.classList.add('hidden');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('form-success-flag')) {
      var container = document.querySelector('.container-form');
      if (container) {
        container.classList.add('hidden');
      }
    }
  });

document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("ContactForm");

  if (form) {
    form.addEventListener("submit", function (e) {
      const formData = new FormData(form);

      const payload = new URLSearchParams();
      for (const [key, value] of formData.entries()) {
        payload.append(key, value);
      }

      // Enviar en segundo plano a tu API
      fetch("https://api-epic.bluecell.tech/send-contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: payload,
      })
      .then((res) => {
        console.log("✅ Enviado a API personalizada:", res);
          if (!res.ok) {
     
          }
          return res.json();
        })
        .then((data) => {
          
        })
        .catch((err) => {
          
        });

  
    });
  }

  // Lógica para ocultar el formulario tras el éxito Shopify
  if (document.getElementById("form-success-flag")) {
    var container = document.querySelector(".container-form");
    if (container) {
      container.classList.add("hidden");
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-bikes"] && !Shopify.designMode) return;
  try {
    
  $('.columns-slide-mobile').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 99999,
        settings: "unslick"
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
        }
      },
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-content-blog"] && !Shopify.designMode) return;
  try {
    
  $('.custom-content-blog .content-slider-imgs').slick({
    variableWidth: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '400px',
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: '60px',
          variableWidth: false,
        }
      },
      {
        breakpoint: 767,
        settings: {
          centerPadding: '30px',
          variableWidth: false,
        }
      }
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-epic-club-benefits"] && !Shopify.designMode) return;
  try {
    

$(".custom-epic-club-benefits .content-tabs .tab").click(function(){
  element=$(this).data("element")
  console.log(element)
  $(".content-tabs .tab").removeClass("active")
  $(this).addClass("active")
  $(".content-tab-info .tab-info").removeClass("active")
  $(".content-tab-info .tab-info[data-element='"+element+"']").addClass("active")
})

$('.custom-epic-club-benefits  .tab-head').click(function(){
  if ($(this).hasClass("open")) {
    $(this).removeClass("open");
    $(this).siblings(".tab-body").slideToggle(500);
    $(this).siblings(".tab-body").find('.tab-body').slideUp(500);
  } else{
    $(this).parents('.container-tab').find('.tab-head').removeClass('open')
    $(this).parent().parent().siblings(".tab-head").addClass("open");
    $(this).addClass("open");
    $(this).siblings(".tab-body").slideToggle(500);
    $(this).parent().nextAll().find('.tab-body').slideUp(500);
    $(this).parent().prevAll().find('.tab-body').slideUp(500);
  }        
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-frequency-questions"] && !Shopify.designMode) return;
  try {
    
// Toggle category view
document.querySelectorAll('.content-items .item').forEach(el => {
  el.addEventListener('click', () => {
    const target = el.dataset.faq;
    document.querySelectorAll('.content-items .item').forEach(i => i.classList.remove('active'));
    el.classList.add('active');

    document.querySelectorAll('.content-faqs .faq').forEach(f => {
      f.classList.remove('active');
      if (f.dataset.faq === target) f.classList.add('active');
    });

    // document.querySelector('.faqs-head')?.classList.add('hide');
    document.querySelector('.content-items')?.classList.add('hide');
    document.querySelector('.content-faqs')?.classList.add('open');
  });
});

// Return to categories
document.querySelectorAll('.content-faqs .faq h2').forEach(el => {
  el.addEventListener('click', () => {
    // document.querySelector('.faqs-head')?.classList.remove('hide');
    document.querySelector('.content-items')?.classList.remove('hide');
    document.querySelector('.content-faqs')?.classList.remove('open');
  });
});

// Toggle accordion
document.querySelectorAll('.accordion-head').forEach(head => {
  head.addEventListener('click', () => {
    const body = head.nextElementSibling;
    const isOpen = head.classList.contains('open');
    document.querySelectorAll('.accordion-head').forEach(h => h.classList.remove('open'));
    document.querySelectorAll('.accordion-body').forEach(b => b.style.display = 'none');
    if (!isOpen) {
      head.classList.add('open');
      body.style.display = 'block';
    }
  });
});

// FAQ search
document.getElementById('faqSearchInput')?.addEventListener('input', function () {
  const query = this.value.toLowerCase().trim();
  const faqs = document.querySelectorAll('.faq');
  const faqContainer = document.querySelector('.content-faqs');
  const header = document.querySelector('.faqs-head');
  const categoryList = document.querySelector('.content-items');

  let anyMatch = false;

  faqs.forEach(faq => {
    let faqMatch = false;

    faq.querySelectorAll('.accordion').forEach(acc => {
      const question = acc.querySelector('h3')?.textContent?.toLowerCase() || '';
      const answer = acc.querySelector('.accordion-body')?.textContent?.toLowerCase() || '';
      const match = question.includes(query) || answer.includes(query);

      acc.style.display = match ? 'block' : 'none';
      if (match) faqMatch = true;
    });

    faq.style.display = faqMatch ? 'block' : 'none';
    if (faqMatch) anyMatch = true;
  });

  if (query.length > 0) {
    // Ocultar cabecera y listado de categorías
    header?.classList.add('hide');
    categoryList?.classList.add('hide');
    faqContainer?.classList.add('open');
  } else {
    // Volver a mostrar cabecera y categorías
    header?.classList.remove('hide');
    categoryList?.classList.remove('hide');
    faqContainer?.classList.remove('open');

    // Restaurar display a todos los accordions
    faqs.forEach(faq => {
      faq.style.display = '';
      faq.querySelectorAll('.accordion').forEach(acc => {
        acc.style.display = '';
      });
    });
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-frequently-asked-questions"] && !Shopify.designMode) return;
  try {
    
  $('.custom-frequently-asked-questions .accordion-head').click(function(){
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $(this).siblings(".accordion-body").slideToggle(500);
      $(this).siblings(".accordion-body").find('.accordion-body').slideUp(500);
    } else{
      $(this).parents('.container-accordion').find('.accordion-head').removeClass('open')
      $(this).parent().parent().siblings(".accordion-head").addClass("open");
      $(this).addClass("open");
      $(this).siblings(".accordion-body").slideToggle(500);
      $(this).parent().nextAll().find('.accordion-body').slideUp(500);
      $(this).parent().prevAll().find('.accordion-body').slideUp(500);
    }        
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-highlight-products"] && !Shopify.designMode) return;
  try {
    
  $('.custom-highlight-products .content-slider').slick({
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.3,
          slidesToScroll: 1,
          dots: true,
          arrows: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          dots: true,
          arrows: true
        }
      }
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-image-slider"] && !Shopify.designMode) return;
  try {
    




  $('.custom-image-slider .slider-gallery').slick({
    dots: true, 
    arrows: true,
    variableWidth: true,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    focusOnSelect: true,
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-info-stores"] && !Shopify.designMode) return;
  try {
    
  $('.slider-team').slick({
    dots: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.3,
          slidesToScroll: 1,
          dots: true,
          arrows: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          dots: true,
          arrows: true
        }
      }
    ]
  });

  if (window.matchMedia("(max-width: 768px)").matches) {

    $('.custom-info-stores .content-columns .column .column-head').click(function () {
      const $this = $(this);
      const $column = $this.closest('.column');
      const $info = $column.find('.column-info');

      // Si ya está abierto, ciérralo
      if ($this.hasClass('open')) {
        $this.removeClass('open');
        $info.slideUp(300);
      } else {
        // Cerrar todos
        $('.content-columns .column .column-head').removeClass('open');
        $('.content-columns .column-info').slideUp(500);

        // Abrir el clicado
        $this.addClass('open');
        $info.slideDown(500);
      }
    });
  }

   document.addEventListener('DOMContentLoaded', function() {
  const slides = document.querySelectorAll('.slide');
  const drawer = document.getElementById('team-drawer');
  const overlay = drawer.querySelector('.team-drawer-overlay');
  const closeBtn = drawer.querySelector('.close-team-drawer');

  slides.forEach(slide => {
    slide.addEventListener('click', function() {
   
      
      drawer.classList.add('active');
      overlay.style.display = 'block';
      // Rellenar contenido
      document.getElementById('drawer-name').textContent = this.dataset.name;
      document.getElementById('drawer-img').src = this.dataset.img;
      const bioHtml = renderRichText(this.dataset.bio);
      document.getElementById('drawer-bio').innerHTML = bioHtml;

      if (this.dataset.store) {
      document.querySelector('.content-list .store').innerHTML = this.dataset.store;
      document.querySelector('.content-store').classList.remove('hidden');
    } else {
      document.querySelector('.content-store').classList.add('hidden');
    }

    if (this.dataset.city) {
      document.querySelector('.content-list .born').innerHTML = this.dataset.city;
      document.querySelector('.content-city-born').classList.remove('hidden');
    } else {
      document.querySelector('.content-city-born').classList.add('hidden');
    }

    if (this.dataset.category) {
      document.querySelector('.content-category').classList.remove('hidden');
      document.querySelector('.content-list .category').innerHTML = this.dataset.category;
    } else {
      document.querySelector('.content-category').classList.add('hidden');
    }

    if (this.dataset.gear) {
      document.querySelector('.content-gear').classList.remove('hidden');
      document.querySelector('.content-list .gear').innerHTML = this.dataset.gear;
    } else {
      document.querySelector('.content-gear').classList.add('hidden');
    }

    if (this.dataset.favplace) {
      document.querySelector('.content-list .place').innerHTML = this.dataset.favplace;
      document.querySelector('.content-favplace').classList.remove('hidden');
    } else {
      document.querySelector('.content-favplace').classList.add('hidden');
    }

    if (this.dataset.beer) {
      document.querySelector('.content-beer').classList.remove('hidden');
      document.querySelector('.content-list .beer').innerHTML = this.dataset.beer;
    } else {
      document.querySelector('.content-beer').classList.add('hidden');
    }
          
    
     
     let races = [];

      try {
        // Convierte &quot; en comillas reales antes de parsear
        const raw = this.dataset.races.replace(/&quot;/g, '"');
        races = JSON.parse(raw);
      } catch (e) {
        races = '';
        
      }

      const racesWrapper = document.querySelector('.content-races');
      const racesListEl = document.querySelector('.content-races .list-races');


      if(races){
        setTimeout(() => {
           
          if (racesListEl) {
            
            racesListEl.innerHTML = races.map(r => `<p>${r}</p>`).join('');
            racesWrapper.classList.remove('hidden');
          }
          }, 0);
          racesWrapper.classList.remove('hidden');
      }else{
         racesListEl.innerHTML = '';
          racesWrapper.classList.add('hidden');
      }
    });
  });

  closeBtn.addEventListener('click', () => {
    drawer.classList.remove('active');
    overlay.style.display = 'none';
  });

  overlay.addEventListener('click', () => {
    drawer.classList.remove('active');
    overlay.style.display = 'none';
  });
});


function renderRichText(jsonString) {
  let html = '';
  try {
    const data = JSON.parse(jsonString);

    if (data?.children?.length) {
      data.children.forEach(block => {
        if (block.type === 'paragraph') {
          block.children.forEach(child => {
            if (child.type === 'text' && child.value) {
              // Maneja múltiples párrafos en un solo valor
              const paragraphs = child.value.split('\n\n');
              paragraphs.forEach(p => {
                html += `<p>${p.trim()}</p>`;
              });
            }
          });
        }
      });
    }
  } catch (e) {
    console.error('Error parsing rich text JSON:', e);
    html = '<p>Error loading description</p>';
  }

  return html;
}


document.addEventListener('DOMContentLoaded', () => {

  const STORAGE_KEY = 'epic_google_reviews_' + $('#reviews-wrapper').data('id_store');
  const CACHE_TTL = 1000 * 60 * 60 * 24 * 3; // 3 días

  const cached = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  const now = Date.now();

  if (cached.reviews && cached.timestamp && now - cached.timestamp < CACHE_TTL) {

    renderAllReviews(cached.reviews);
  } else {
    // Hacer fetch solo si no hay cache o está vencido
    const API_URL = 'https://api-epic.bluecell.tech/api/place-id-and-reviews?store_name=' + $('#reviews-wrapper').data('id_store') + '&address=' + $('#reviews-wrapper').data('query') + '&stars=5';

    fetch(API_URL)
      .then(res => res.json())
      .then(data => {
        if (!data.reviews?.length) return;

        // Guardar en cache
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          reviews: data.reviews,
          timestamp: Date.now()
        }));

        renderAllReviews(data.reviews);
      })
      .catch(err => console.error('Error fetching reviews:', err));
  }

  function renderAllReviews(reviews) {
    const previewContainer = document.querySelector('.custom-reviews .content-reviews');
    const popupContainer = document.querySelector('.popup-container-reviews .content-reviews');

    previewContainer.innerHTML = '';
    popupContainer.innerHTML = '';

    reviews.slice(0, 3).forEach(r => previewContainer.innerHTML += renderReview(r));
    reviews.slice(3).forEach(r => popupContainer.innerHTML += renderReview(r));
  }

  function renderReview(review) {
    const stars = '<i class="fa-solid fa-star"></i>'.repeat(review.rating);
    const date = new Date(review.time * 1000).toLocaleDateString();

    return `
      <div class="review">
        <div class="content-stars-date">
          <div class="content-stars">${stars}</div>
          <div class="content-date"><p>${date}</p></div>
        </div>
        <div class="content-info">
          <h6>${review.author_name}</h6>
          <p class="name">via Google</p>
          <p>${review.text}</p>
        </div>
      </div>
    `;
  }
});

document.addEventListener("DOMContentLoaded", async () => {

  const storeSelected = await window.SearchActualStore();
  
  const storeWrapper = document.querySelector(".select-favorite-store-wrapper").dataset.name?.trim() || '';
  
  if (storeWrapper == storeSelected) {
    const heartIcon = document.querySelector(".select-favorite-store-wrapper .icon-heart");
    const titleLabel = document.querySelector(".select-favorite-store-wrapper .title-store");

    if (heartIcon) {
      heartIcon.setAttribute("icon", "mdi:heart");
      heartIcon.classList.add("filled");
    }

    if (titleLabel) {
      titleLabel.textContent = "Favorite store";
    }
    
  }
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".select-favorite-store-wrapper").forEach(wrapper => {
    wrapper.addEventListener("click", () => {
      const storeName = wrapper.dataset.name?.trim();
      console.log(storeName);
      if (!storeName || !window.saveFavoriteStore) return;

      // Limpiar todos los corazones anteriores
      document.querySelectorAll(".select-favorite-store-wrapper").forEach(el => {
        el.querySelector(".icon-heart")?.setAttribute("icon", "mdi:heart-outline");
        el.querySelector(".icon-heart")?.classList.remove("filled");
        const label = el.querySelector(".title-store");
        if (label) label.textContent = "Select as favorite";

      });

      // Actualizar este
      const heartIcon = wrapper.querySelector(".icon-heart");
      const titleLabel = wrapper.querySelector(".title-store");

      if (heartIcon) {
        heartIcon.setAttribute("icon", "mdi:heart");
        heartIcon.classList.add("filled");
      }

      if (titleLabel) {
        titleLabel.textContent = "Favorite store";
      }

      // Llama a la función de guardado (puede ser solo nombre si no hay un .item)
      window.saveFavoriteStore(storeName);
    });
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-list-and-image"] && !Shopify.designMode) return;
  try {
    

  $('.custom-list-and-image .content-slider-img').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: true,
    asNavFor: '.content-slider-text',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
          dots: false,
          // vertical: false,
        }
      }
    ]
  });

  $('.custom-list-and-image .content-slider-text').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.content-slider-img',
    vertical: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          arrows: true,
          dots: true,
          vertical: false,
          adaptiveHeight: true,
        }
      }
    ]
  });
		

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-menu-stores"] && !Shopify.designMode) return;
  try {
    
  $('.slider-team').slick({
    dots: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.3,
          slidesToScroll: 1,
          dots: true,
          arrows: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          dots: true,
          arrows: true
        }
      }
    ]
  });

  if (window.matchMedia("(max-width: 768px)").matches) {

    $('.custom-info-stores .content-columns .column .column-head').click(function () {
      const $this = $(this);
      const $column = $this.closest('.column');
      const $info = $column.find('.column-info');

      // Si ya está abierto, ciérralo
      if ($this.hasClass('open')) {
        $this.removeClass('open');
        $info.slideUp(300);
      } else {
        // Cerrar todos
        $('.content-columns .column .column-head').removeClass('open');
        $('.content-columns .column-info').slideUp(500);

        // Abrir el clicado
        $this.addClass('open');
        $info.slideDown(500);
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-our-activity-strava"] && !Shopify.designMode) return;
  try {
    

  $('.container-our-activity .slider-activity').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    arrows: true,
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-details-slider"] && !Shopify.designMode) return;
  try {
    

  // Cerrar details
  $('.custom-product-details-slider').on('click', 
    '.slick-dots li, .slick-arrow, .content-details-product .content-details .content-close', 
    function(e) {
      $(".slide").removeClass("open");
      $(".content-slider-product").removeClass("open");
      $(".content-details").removeClass("open");
    }
  );

  // Redimensionar Slider - Versión Unificada
  function resizeSlider() {
    const slider = $('.content-slider-product');
    setTimeout(function () {
      slider.slick('setPosition');
    }, 1);
  }
  // Event listeners unificados
  $('.custom-product-details-slider').on('click', 
    '.slide .content-label, .slick-dots li, .slick-arrow, .content-details-product .content-details .content-close', 
    function(e) {
      console.log("Slider resize triggered by:", e.target.className);
      resizeSlider();
    }
  );

  $(".custom-product-details-slider .slide .content-label").click(function () {
    const product = $(this).data("product");

    // Cierra todo
    $(".slide").removeClass("open");
    $(".content-details").removeClass("open");

    // Abre el slide actual y el detalle correspondiente
    // $(this).closest(".slide").addClass("open");
    $(this).closest(".content-slider-product").addClass("open");
    $(".content-details[data-product='" + product + "']").addClass("open");
  });

  $('.content-slider-product').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    infinite: false,
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-reviews"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

  const STORAGE_KEY = 'epic_google_reviews_' + $('#reviews-wrapper').data('id_store');
  const CACHE_TTL = 1000 * 60 * 60 * 24 * 3; // 3 días

  const cached = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  const now = Date.now();

  if (cached.reviews && cached.timestamp && now - cached.timestamp < CACHE_TTL) {

    renderAllReviews(cached.reviews);
  } else {
    // Hacer fetch solo si no hay cache o está vencido
    const API_URL = 'https://api-epic.bluecell.tech/api/place-id-and-reviews?store_name=' + $('#reviews-wrapper').data('id_store') + '&address=' + $('#reviews-wrapper').data('query') + '&stars=5';

    fetch(API_URL)
      .then(res => res.json())
      .then(data => {
        if (!data.reviews?.length) return;

        // Guardar en cache
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          reviews: data.reviews,
          timestamp: Date.now()
        }));

        renderAllReviews(data.reviews);
      })
      .catch(err => console.error('Error fetching reviews:', err));
  }

  function renderAllReviews(reviews) {
    const previewContainer = document.querySelector('.custom-reviews .content-reviews');
    const popupContainer = document.querySelector('.popup-container-reviews .content-reviews');

    previewContainer.innerHTML = '';
    popupContainer.innerHTML = '';

    reviews.slice(0, 3).forEach(r => previewContainer.innerHTML += renderReview(r));
    reviews.slice(3).forEach(r => popupContainer.innerHTML += renderReview(r));
  }

  function renderReview(review) {
    const stars = '<i class="fa-solid fa-star"></i>'.repeat(review.rating);
    const date = new Date(review.time * 1000).toLocaleDateString();

    return `
      <div class="review">
        <div class="content-stars-date">
          <div class="content-stars">${stars}</div>
          <div class="content-date"><p>${date}</p></div>
        </div>
        <div class="content-info">
          <h6>${review.author_name}</h6>
          <p class="name">via Google</p>
          <p>${review.text}</p>
        </div>
      </div>
    `;
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-services"] && !Shopify.designMode) return;
  try {
    
  if (window.matchMedia("(max-width: 768px)").matches) {

    $('.custom-services .content-info .content-columns .column h3').click(function () {
      const $this = $(this);
      const $column = $this.closest('.column');
      const $info = $column.find('.column-info');

      // Si ya está abierto, ciérralo
      if ($this.hasClass('open')) {
        $this.removeClass('open');
        $info.slideUp(300);
      } else {
        // Cerrar todos
        $('.content-columns .column h3').removeClass('open');
        $('.content-columns .column-info').slideUp(500);

        // Abrir el clicado
        $this.addClass('open');
        $info.slideDown(500);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-slider-itinerary"] && !Shopify.designMode) return;
  try {
    

  $('.custom-slider-itinerary .slider-itinerary').slick({
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          adaptiveHeight: true,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
          slidesToScroll: 1,
        }
      }
    ]
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-slider-team"] && !Shopify.designMode) return;
  try {
    
  $('.custom-slider-team').slick({
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.3,
          slidesToScroll: 1,
          dots: true,
          arrows: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          dots: true,
          arrows: true
        }
      }
    ]
  });


  document.addEventListener('DOMContentLoaded', function() {
  const slides = document.querySelectorAll('.slide');
  const drawer = document.getElementById('team-drawer');
  const overlay = drawer.querySelector('.team-drawer-overlay');
  const closeBtn = drawer.querySelector('.close-team-drawer');

  slides.forEach(slide => {
    slide.addEventListener('click', function() {
      drawer.classList.add('active');
      overlay.style.display = 'block';
      // Rellenar contenido
      document.getElementById('drawer-name').textContent = this.dataset.name;
      document.getElementById('drawer-img').src = this.dataset.img;
      const bioHtml = renderRichText(this.dataset.bio);
      document.getElementById('drawer-bio').innerHTML = bioHtml;

      if (this.dataset.store) {
      document.querySelector('.content-list .store').innerHTML = this.dataset.store;
      document.querySelector('.content-store').classList.remove('hidden');
    } else {
      document.querySelector('.content-store').classList.add('hidden');
    }

    if (this.dataset.city) {
      document.querySelector('.content-list .born').innerHTML = this.dataset.city;
      document.querySelector('.content-city-born').classList.remove('hidden');
    } else {
      document.querySelector('.content-city-born').classList.add('hidden');
    }

    if (this.dataset.category) {
      document.querySelector('.content-category').classList.remove('hidden');
      document.querySelector('.content-list .category').innerHTML = this.dataset.category;
    } else {
      document.querySelector('.content-category').classList.add('hidden');
    }

    if (this.dataset.gear) {
      document.querySelector('.content-gear').classList.remove('hidden');
      document.querySelector('.content-list .gear').innerHTML = this.dataset.gear;
    } else {
      document.querySelector('.content-gear').classList.add('hidden');
    }

    if (this.dataset.favplace) {
      document.querySelector('.content-list .place').innerHTML = this.dataset.favplace;
      document.querySelector('.content-favplace').classList.remove('hidden');
    } else {
      document.querySelector('.content-favplace').classList.add('hidden');
    }

    if (this.dataset.beer) {
      document.querySelector('.content-beer').classList.remove('hidden');
      document.querySelector('.content-list .beer').innerHTML = this.dataset.beer;
    } else {
      document.querySelector('.content-beer').classList.add('hidden');
    }
          
    
     
     let races = [];

      try {
        // Convierte &quot; en comillas reales antes de parsear
        const raw = this.dataset.races.replace(/&quot;/g, '"');
        races = JSON.parse(raw);
      } catch (e) {
        races = '';
        
      }

      const racesWrapper = document.querySelector('.content-races');
      const racesListEl = document.querySelector('.content-races .list-races');


      if(races){
        setTimeout(() => {
           
          if (racesListEl) {
            
            racesListEl.innerHTML = races.map(r => `<p>${r}</p>`).join('');
            racesWrapper.classList.remove('hidden');
          }
          }, 0);
          racesWrapper.classList.remove('hidden');
      }else{
         racesListEl.innerHTML = '';
          racesWrapper.classList.add('hidden');
      }
    });
  });

  closeBtn.addEventListener('click', () => {
    drawer.classList.remove('active');
    overlay.style.display = 'none';
  });

  overlay.addEventListener('click', () => {
    drawer.classList.remove('active');
    overlay.style.display = 'none';
  });
});


function renderRichText(jsonString) {
  let html = '';
  try {
    const data = JSON.parse(jsonString);

    if (data?.children?.length) {
      data.children.forEach(block => {
        if (block.type === 'paragraph') {
          block.children.forEach(child => {
            if (child.type === 'text' && child.value) {
              // Maneja múltiples párrafos en un solo valor
              const paragraphs = child.value.split('\n\n');
              paragraphs.forEach(p => {
                html += `<p>${p.trim()}</p>`;
              });
            }
          });
        }
      });
    }
  } catch (e) {
    console.error('Error parsing rich text JSON:', e);
    html = '<p>Error loading description</p>';
  }

  return html;
}




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-text-in-columns"] && !Shopify.designMode) return;
  try {
    
  $('.columns-slide-mobile').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 99999,
        settings: "unslick"
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
        }
      },
    ]
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-two-column-list"] && !Shopify.designMode) return;
  try {
    

  $('.custom-two-column-list.content-included-notincluded').slick({
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick'
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
        }
      }
    ]
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-two-column-slider"] && !Shopify.designMode) return;
  try {
    
  $('.custom-two-column-slider').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    arrows: true,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-video"] && !Shopify.designMode) return;
  try {
    
  $(".content-video-cover").click(function () {
    $(this).hide();
    var iframe = $(this).siblings('iframe');
    var video = $(this).siblings('video');

    if (iframe.length > 0) {
      var videoSrc = iframe.attr("src");
      if (videoSrc && !videoSrc.includes("autoplay=1")) {
        var separator = videoSrc.includes("?") ? "&" : "?";
        iframe.attr("src", videoSrc + separator + "autoplay=1");
      }
    } else if (video.length > 0) {
      video.get(0).play();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-you-may-be-interested"] && !Shopify.designMode) return;
  try {
      
  $('.featured-blog.content-highlights .slider-highlights').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
     

  $('.featured-blog.content-highlights .slider-highlights').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
  });


document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const tag = params.get('tag');

  if (!tag) return; // Si no hay tag, no cargar por AJAX

  const target = document.querySelector('.box-news');
  const encodedTag = encodeURIComponent(tag);
  console.log('Loading articles for tag:', encodedTag);
  const blogHandle = target && target.dataset.blogHandle ? target.dataset.blogHandle : 'epic';
  const url = `/blogs/${blogHandle}/tagged/${encodedTag}?view=card`;

  target.innerHTML = '<p>Loading...</p>';

  fetch(url)
    .then(res => res.text())
    .then(html => {
      const temp = document.createElement('div');
      temp.innerHTML = html;

      const content = temp.querySelector('.box-news');
      target.innerHTML = content ? content.innerHTML : '<p>No articles found.</p>';
    })
    .catch(() => {
      target.innerHTML = '<p>Error loading articles.</p>';
    });
});


  document.addEventListener('DOMContentLoaded', function () {

    
    const params = new URLSearchParams(window.location.search);
    const currentTag = params.get('tag') || '';
   
    // Normalizar para comparación
    const normalizedTag = decodeURIComponent(currentTag.replace(/\+/g, ' ')).toLowerCase();
    setTimeout(function() { 
      $('#load-more').attr('data-tag', normalizedTag);
        console.log('Tag for load more:', normalizedTag);
    }, 1000);
    
  // Eliminar clases activas previas
      document.querySelectorAll('.filter-link').forEach(link => {
        link.classList.remove('active');
      });

      // Buscar y marcar el filtro correspondiente
      let matched = false;
      document.querySelectorAll('.filter-link').forEach(link => {
        const hrefTag = new URLSearchParams(link.getAttribute('href').split('?')[1] || '').get('tag') || '';
        var tag = hrefTag.split('#')[0].toLowerCase();
       
   
        const normalizedHrefTag = decodeURIComponent(hrefTag.replace(/\+/g, ' ')).toLowerCase();
    
        if (normalizedTag === tag) {
          link.classList.add('active');
          matched = true;
        }
      });
    
    

    // Si no hay coincidencia, activa "View all"
    if (!matched) {
      const viewAll = document.querySelector('.filter-link[href="?tag="]');
      if (viewAll) viewAll.classList.add('active');
    }
  });


document.addEventListener('DOMContentLoaded', function () {
  const loadMoreBtn = document.getElementById('load-more');
  const wrapper = document.getElementById('load-more-wrapper');
  const container = document.querySelector('.box-news');

  if (!loadMoreBtn || !container) return;

  loadMoreBtn.addEventListener('click', function () {

    
    const tag = loadMoreBtn.dataset.tag;
    let page = parseInt(loadMoreBtn.dataset.page);

    const blogHandle = container && container.dataset.blogHandle ? container.dataset.blogHandle : 'epic';
    const url = tag
      ? `/blogs/${blogHandle}/tagged/${encodeURIComponent(tag)}?page=${page}&view=card`
      : `/blogs/${blogHandle}?page=${page}&view=card`;

    loadMoreBtn.disabled = true;
    loadMoreBtn.textContent = 'Loading...';

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const temp = document.createElement('div');
        temp.innerHTML = html;

        const newContent = temp.querySelector('.box-news');
        const hasMore = temp.querySelector('.ajaxinate-trigger');

        if (newContent) {
          container.insertAdjacentHTML('beforeend', newContent.innerHTML);
          page += 1;
          loadMoreBtn.dataset.page = page;
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = 'Ver más';
        }

        if (!hasMore) {
          wrapper.style.display = 'none';
        }
      })
      .catch(() => {
        loadMoreBtn.textContent = 'Error';
      });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function() { 
    const wrapper = document.getElementById('load-more-wrapper');
    const cards = document.querySelectorAll('.box-news > a'); // selecciona correctamente los artículos
  
    if (wrapper) {
      if (cards.length < 9) {
        wrapper.classList.add('hidden');
      } else {
        wrapper.classList.remove('hidden');
      }
    }
  }, 1000);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${
        this.header.offsetHeight
      }px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }

  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
